import { sbaAxios } from "../utils/sbaAxios";
import {getHoldings ,getHoldingsSummary,getHoldingData} from "../../config/apiConfig";
import {
  FETCH_HOLDING_DATA_BEGIN,
  FETCH_HOLDING_DATA_SUCCESS,
  FETCH_HOLDING_DATA_FAILURE,
  FETCH_HOLDING_SUMMARY_BEGIN,
  FETCH_HOlDING_SUMMARY_SUCCESS,
  FETCH_HOLDING_SUMMARY_FAILURE,
  FETCH_HOLDING_TOPLONGGRIDDATA_BEGIN,
  FETCH_HOlDING_TOPLONGGRIDDATA_SUCCESS,
  FETCH_HOLDING_TOPLONGGRIDDATA_FAILURE,
  FETCH_HOLDING_SHORTLONGGRIDDATA_BEGIN,
  FETCH_HOLDING_SHORTLONGGRIDDATA_SUCCESS,
  FETCH_HOLDING_SHORTLONGGRIDDATA_FAILURE
  } from '../constants/holding';




//Holding Grid Data 
export const getHoldingDataAction=(AssetID,StartDate,EndDate)=>{
  return (dispatch) => {
      dispatch(getHoldingDataActionBegin());
      sbaAxios({
          url: `${getHoldingData}${AssetID},${StartDate},${EndDate},0`,
          method: 'get',
      })                 .then((repos) => {
                     const HoldingData = repos;
                     const FormattedData= repos.map(item=>(
                      {...item,ReportDate:new Date(item.ReportDate.split("T")[0]), MktValueDate :new Date(item.MktValueDate.split("T")[0])}
                      ));
                    dispatch(getHoldingDataActionSuccess(FormattedData));
            })
      .catch((error) => dispatch(getHoldingDataActionFailure(error)));
  };
}

const getHoldingDataActionBegin=()=>({
  type: FETCH_HOLDING_DATA_BEGIN
})

const getHoldingDataActionSuccess=(HoldingData)=>({
  type: FETCH_HOLDING_DATA_SUCCESS,
  payload:{HoldingData}
})

const getHoldingDataActionFailure=(error)=>({
  type: FETCH_HOLDING_DATA_FAILURE,
  payload:{error}
})

//Holding Summary Action
export const getHoldingSummaryAction=(AssetID)=>{
  return (dispatch) => {
      dispatch(getHoldingSummaryActionBegin());
      sbaAxios({
          url: `${getHoldingsSummary}${AssetID},9-30-2022,1,2`,
          method: 'get',
      })
                    .then((repos) => {
                     const HoldingSummary = repos;
                    dispatch(getHoldingSummaryActionSuccess(HoldingSummary));
            })
      .catch((error) => dispatch(getHoldingSummaryActionFailure(error)));
  };
}

const getHoldingSummaryActionBegin=()=>({
  type: FETCH_HOLDING_SUMMARY_BEGIN
})

const getHoldingSummaryActionSuccess=(HoldingSummary)=>({
  type: FETCH_HOlDING_SUMMARY_SUCCESS,
  payload:{HoldingSummary}
})

const getHoldingSummaryActionFailure=(error)=>({
  type: FETCH_HOLDING_SUMMARY_FAILURE,
  payload:{error}
})


//Top long holding grid data

export const getHoldingLongAction=(AssetID,endDate,incOption ,aggregation,outputData )=>{
  return (dispatch) => {
    if(outputData==6)
    {
        dispatch(getHoldingTopLongActionBegin());
        sbaAxios({
            url: `${getHoldings}${AssetID},${endDate},${incOption},${aggregation},${outputData}`,
            method: 'get',
        })
                    .then((repos) => {
                     const TopLongHolding = repos;
                    dispatch(getHoldingTopLongActionSuccess(TopLongHolding));
            })
      .catch((error) => dispatch(getHoldingTopLongActionFailure(error)));
  }
  else if(outputData==7)
    {
        dispatch(getHoldingShortLongActionBegin());
        sbaAxios({
            url: `${getHoldings}${AssetID},${endDate},${incOption},${aggregation},${outputData}`,
            method: 'get',
        })
                    .then((repos) => {
                     const shortLongHolding = repos;
                    dispatch(getHoldingShortLongActionSuccess(shortLongHolding));
                    return shortLongHolding;
            })
      .catch((error) => dispatch(getHoldingShortLongActionFailure(error)));
  };
  }
  
}

const getHoldingTopLongActionBegin=()=>({
  type: FETCH_HOLDING_TOPLONGGRIDDATA_BEGIN
})

const getHoldingTopLongActionSuccess=(TopLongHolding)=>({
  type: FETCH_HOlDING_TOPLONGGRIDDATA_SUCCESS,
  payload:{TopLongHolding}
})

const getHoldingTopLongActionFailure=(error)=>({
  type: FETCH_HOLDING_TOPLONGGRIDDATA_FAILURE,
  payload:{error}
})


const getHoldingShortLongActionBegin=()=>({
  type: FETCH_HOLDING_SHORTLONGGRIDDATA_BEGIN
})

const getHoldingShortLongActionSuccess=(shortLongHolding)=>({
  type: FETCH_HOLDING_SHORTLONGGRIDDATA_SUCCESS,
  payload:{shortLongHolding}
})

const getHoldingShortLongActionFailure=(error)=>({
  type: FETCH_HOLDING_SHORTLONGGRIDDATA_FAILURE,
  payload:{error}
})